export default "__VITE_ASSET__59e2eb2f__"